<template>
  <v-container class="pt-0">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="titleHeader" />
      </v-col>
    </v-row>

    <v-row class="justify-center mt-6">
      <div v-if="site.invite_point > 0">
        <v-col cols="12" class="pa-1">
          <p class="text-center text-h6 mb-0">
            {{ site.invite_point | commaPoint }} {{ $t("coin") }}
          </p>
        </v-col>
        <v-col>
          <p class="text-center">
            {{ $t("inviteFrindDetail") }} <br />{{ $t("received") }}
            {{ site.invite_point | commaPoint }} {{ $t("coin") }}
          </p>
        </v-col>
      </div>
      <div v-else>
        <v-col cols="12" class="pt-2 pb-0">
          <p class="text-center text-h6 mb-0">{{ $t("inviteHeadline") }}</p>
        </v-col>
        <v-col>
          <p class="text-center">{{ $t("inviteFriendNow") }}</p>
        </v-col>
      </div>
      <v-col cols="12">
        <v-img
          class="white--text align-end mx-auto"
          :lazy-src="require('@/assets/images/image.png')"
          :src="require('@/assets/images/invite-friend.png')"
          max-width="350px"
        >
        </v-img>
      </v-col>
    </v-row>
    <v-row
      v-if="checkLimitInvite && checkInviteLine"
      class="mt-3 mb-1 justify-center"
    >
      <v-btn
        width="350"
        height="50"
        style="border-color: #39cd08"
        outlined
        class="rounded-lg"
        @click="updateInviteLine()"
      >
        <ShareNetwork
          network="line"
          :url="link"
          :title="title"
          style="text-decoration: none"
          class="mx-2"
        >
          <div class="mx-auto py-2">
            <v-row>
              <v-img
                :src="require('@/assets/social/line-circle.svg')"
                style="width: 30px; height: 30px"
                class="mx-auto d-block"
              ></v-img>
              <p class="mx-2 d-block my-1" style="color: #39cd08">
                {{ $t("inviteFriendLineText") }}
              </p>
            </v-row>
          </div>
        </ShareNetwork>
      </v-btn>
    </v-row>
    <v-row
      v-if="checkLimitInvite && checkInviteLink"
      class="mt-0 mb-4 mt-4 justify-center"
    >
      <v-btn
        width="350"
        height="50"
        :style="{ borderColor: site.color }"
        outlined
        class="rounded-lg"
        @click="onCopyLink()"
      >
        <div class="mx-auto py-2">
          <v-row>
            <v-icon :color="site.color">mdi-content-copy</v-icon>
            <p class="mx-2 d-block my-1 black--text">
              {{ $t("copyInviteLink") }}
            </p>
          </v-row>
        </div>
      </v-btn>
    </v-row>
    <v-row
      v-if="
        checkLimitInvite &&
        checkInvitePhone &&
        (checkInviteLine || checkInviteLink)
      "
      class="mb-4"
    >
      <v-col class="d-flex justify-center align-center py-1">
        <v-divider class="mr-2"></v-divider>
        <span class="grey--text">{{ $t("or") }}</span>
        <v-divider class="ml-2"></v-divider>
      </v-col>
    </v-row>
    <v-row
      v-if="checkLimitInvite && checkInvitePhone"
      class="mt-0 justify-center"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-actions>
          <v-text-field
            :color="site.color"
            :label="$t('fillPhone')"
            v-model="mobile"
            outlined
            :rules="phoneRules"
            required
            style="width: 350px"
            class="rounded-lg"
          ></v-text-field>
        </v-card-actions>
      </v-form>
    </v-row>
    <v-btn
      v-if="checkLimitInvite && checkInvitePhone"
      :color="site.color"
      class="white--text rounded-lg d-block mx-auto mt-2"
      @click="invite()"
      width="350"
    >
      {{ $t("inviteFriend") }}
    </v-btn>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import headerTextBg from "../../../components/headerTextBg.vue";

export default {
  name: "Invite",
  inject: ["isAppLoading"],
  components: { headerTextBg },

  data: () => {
    return {
      drawer: false,
      code: "",
      link: "",
      title: "",
      group: null,
      dialog: false,
      valid: true,
      mobile: "",
    };
  },

  created() {
    this.isAppLoading(true);

    this.code = this.genCodeInvite();
    this.genTitleInvite();

    setTimeout(() => {
      this.genLinkInvite();
      this.isAppLoading(false);
    }, 1000);
  },
  methods: {
    updateInviteLine() {
      Axios.post("invite/createLine", {
        code: this.code,
        link: this.link,
        message: this.title,
      }).then(({ data }) => {
        console.log("data :>> ", data);
      });
    },
    genTitleInvite() {
      this.title = this.$t("titleInvite", {
        name: this.site.name,
      });
    },
    genLinkInvite() {
      this.link =
        this.customer.site + "?invite=" + this.code + "&platform=Line";
      console.log("link :>> ", this.link);
    },
    genCodeInvite() {
      var b = 62;
      var num = Date.now() + Math.floor(Math.random() * 9000) + 1000;
      var base =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var r = num % b;
      var res = base.charAt(r);
      var q = Math.floor(num / b);

      while (q) {
        r = q % b;
        q = Math.floor(q / b);
        res = base.charAt(r) + res;
      }

      return res;
    },
    invite() {
      if (!this.$refs.form.validate()) {
        return;
      }

      Axios.post("invite/create", { mobile: this.mobile })
        .then(({ data }) => {
          this.$swal
            .fire({
              icon: "success",
              title: data.message,
              showConfirmButton: false,
              timer: 1500,
            })
            .then(() => {
              this.dialog = false;
            });
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    async onCopyLink() {
      const link = this.customer.site + "?invite=" + this.code;
      try {
        await Axios.post("invite/createLink", {
          code: this.code,
          link: link,
          message: this.title,
        });
      } catch (err) {
        console.log("onCopyLink:err", err);
      }
      const text = this.title + " " + link;
      navigator.clipboard.writeText(text);
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 2000,
      });
      Toast.fire({
        icon: "success",
        title: this.$t("copyInviteLinkSuccess"),
      });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    phoneRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) =>
          /^(08|06|09)\d{8}$/.test(v) || this.$t("validation.phoneInvalid"),
      ];
    },
    checkInviteLine() {
      let check = false;
      if (this.site?.invite_data?.use_line) {
        check = true;
      }
      return check;
    },
    checkInviteLink() {
      let check = false;
      if (this.site?.invite_data?.use_link) {
        check = true;
      }
      return check;
    },
    checkInvitePhone() {
      let check = false;
      if (this.site?.invite_data?.use_phone) {
        check = true;
      }
      return check;
    },
    titleHeader() {
      let limitText = ``;
      const invite_data = this.site?.invite_data;
      if (invite_data && invite_data?.use_limit) {
        const invite_count = this.site.invite_count || 0;
        const limit = invite_data?.limit || 0;
        limitText = ` (${invite_count}/${limit})`;
      }
      let title = `${this.$t("invitePage")} ${limitText}`;
      return title;
    },
    checkLimitInvite() {
      let check = true;
      const invite_data = this.site?.invite_data;
      if (invite_data && invite_data?.use_limit) {
        const invite_count = this.site.invite_count || 0;
        const limit = invite_data?.limit || 0;
        if (limit <= invite_count) {
          check = false;
        }
      }
      return check;
    },
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (!value) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>
